import React, { FC } from 'react';
import classNames from 'classnames';
import {useStoreon} from 'storeon/react';
import { AsyncPaginate } from 'react-select-async-paginate';
import { api } from '@/api';
import { TLabelAndValue } from '@/types';
import styles from '../../styles/index.module.scss';
import { styleMultiSelectUser } from '../../const';
import {ISelect} from '../../interfaces';

const MultiSelectGroups: FC<ISelect> = ({ onChangeSelect, classNameBlock, flagStaff, value }) => {
  /**
   * Todo: Узнать актуальность (currentUser не имеет поля groups)
   */
  const { currentUser } = useStoreon('currentUser')
  const loadOptions = async () => {
    let options:TLabelAndValue[] = [];
    const response = await api.user.getGroups();
    if(flagStaff ){
      response.map((el) => 
        currentUser.groups.forEach((group: Record<string, any>) => {
          if (group.id === el.id) {
            options.push({
              value: el.id,
              label: el.name,
            })
          }
        })
      )
    }else {
      options = response.map((el) => {
        return {
          value: el.id,
          label: el.name,
        }
      })
    }
    return {
      options
    }
  }

  

  return (
    <AsyncPaginate
      aria-labelledby="label-users"
      isMulti
      name="users"
      value={value}
      className={classNames(styles['item-select'], classNameBlock)}
      onChange={(e: any) => {
        onChangeSelect(e);
      }}
      isClearable={false}
      placeholder='Выберите'
      loadOptions={loadOptions}
      styles={styleMultiSelectUser}
      noOptionsMessage={() => 'Ничего не найдено'}
      loadingMessage={() => 'Поиск...'}
    />
  );
};

export default MultiSelectGroups;